/* eslint-disable */
export default {
  unmute: '음소거 해제',
  mute: '음소거',
  keypad: '키패드',
  hold: '대기',
  onHold: '대기 중',
  park: '대기 중',
  stopRecord: '중지',
  record: '레코드',
  add: '추가',
  transfer: '전달',
  flip: '전환',
  more: '통화 동작',
  mergeToConference: '병합',
  end: '종료',
  completeTransfer: '완료\n전달',
} as const;

// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"park"@#@ @source: @#@"Park"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"more"@#@ @source: @#@"Call Actions"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete\nTransfer"@#@
